import React from 'react';
import {IoCheckmarkDoneSharp} from "react-icons/io5";
import {FaClock, FaTrash} from "react-icons/fa";

const UsersReceiverStatusCell = ({value}) => {
    return (
        <div className="w-full h-full flex justify-center items-center">
            {
                value === "NEW" &&
                <IoCheckmarkDoneSharp className={"text-17"}  title={"Não visualizado"}/>
            }
            {
                value === "VIEWED" &&
                <IoCheckmarkDoneSharp className={"text-17"} color={"#1588F3"}  title={"Visualizado"}/>
            }
            {
                value === "EXCLUDED" &&
                <FaTrash color={"#ed5565"}/>
            }
            {
                value === "EXPIRED" &&
                <FaClock color={"#f8ac59"}/>
            }
        </div>
    );
};

export default UsersReceiverStatusCell;